import { render, staticRenderFns } from "./send-rule-edit.vue?vue&type=template&id=bf9269d2&scoped=true&"
import script from "./send-rule-edit.vue?vue&type=script&lang=js&"
export * from "./send-rule-edit.vue?vue&type=script&lang=js&"
import style0 from "./send-rule-edit.vue?vue&type=style&index=0&id=bf9269d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9269d2",
  null
  
)

export default component.exports